/** Read-only star rating display. Coerces value (Postgres numerics arrive as strings). */
export function Stars({ value, count, className = "" }: { value: number | string | null | undefined; count?: number; className?: string }) {
  const v = Number(value) || 0;
  const full = Math.max(0, Math.min(5, Math.round(v)));
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} aria-label={`${v.toFixed(1)} out of 5${count != null ? `, ${count} reviews` : ""}`}>
      <span className="font-mono text-accent">
        {"★".repeat(full)}<span className="text-line">{"★".repeat(5 - full)}</span>
      </span>
      <span className="font-mono text-xs text-muted">{v.toFixed(1)}{count != null ? ` (${count})` : ""}</span>
    </span>
  );
}
